import { DealerAddressInfoDTO, DeliveryModeDTO, WarrantyRegistrationDTO, DealerLocationDTO } from 'src/services/generated/api.generated.v1';
import { AddressInfo, OrderTypeOption } from './../../components/models';
export interface OrderInfoInterface {
  dealerLocation: DealerLocationDTO | null;
  reference : string | null;
  requisition : string | null;
  modeOfDelivery: DeliveryModeDTO | null;
  orderType: OrderTypeOption | null;
  vin: WarrantyRegistrationDTO | null;
  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  deliveryName: string| null;
  oneTimeDelivery: boolean;
  deliveryAddress: DealerAddressInfoDTO | null;
  addressInfo: AddressInfo | null;
  shippingName: string | null;
  shippingPhone: string | null;
}

function state(): OrderInfoInterface {
  return {
    dealerLocation: null,
    reference : null,
    requisition : null,
    modeOfDelivery : null,
    orderType : null,
    vin : null,
    contactName : null,
    contactEmail : null,
    contactPhone : null,
    deliveryName: null,
    oneTimeDelivery : false,
    deliveryAddress: null,
    addressInfo : null,
    shippingName : null,
    shippingPhone : null,
  }
}

export default state;
